import { useRef, useCallback } from 'react';

// Global cache to persist across component unmounts
const globalCache = new Map();

export const useApiCache = () => {
  const getCachedData = useCallback((key) => {
    const cached = globalCache.get(key);
    if (cached && Date.now() - cached.timestamp < 5 * 60 * 1000) { // 5 minutes cache
      return cached.data;
    }
    return null;
  }, []);

  const setCachedData = useCallback((key, data) => {
    globalCache.set(key, {
      data,
      timestamp: Date.now()
    });
  }, []);

  const clearCache = useCallback((key) => {
    if (key) {
      globalCache.delete(key);
    } else {
      globalCache.clear();
    }
  }, []);

  return {
    getCachedData,
    setCachedData,
    clearCache
  };
};
